import { DestinationItemType } from '@tableau/nested-project-explorer';

import { CommonErrorCode, ContentErrorCode, MetricErrorCode, TagErrorCode } from '~commonInfra/utils/ErrorCodes';
import {SessionSiteSelectors} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { IMetricInfo } from '../models/IMetricInfo';
import { MetricContentType } from '../models/MetricContentType';
export namespace MetricErrors {

  export function errorDetailsFor(metricErrorItem: IErrorItem<IMetricInfo>, destinationType?: DestinationItemType): IErrorDetail {
    return {
      itemName: metricErrorItem.item.name,
      itemUrl:
          metricErrorItem.error.code === MetricErrorCode.MetricNotFound
          ? null
          : ContentUrlForItem(metricErrorItem.item, MetricContentType),
      errorMessage: this.errorMessageFor(metricErrorItem, destinationType)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IMetricInfo>, destinationType: DestinationItemType) {
    const metric = errorItem.item;
    switch (errorItem.error.code) {
      case MetricErrorCode.MetricNotFound:
        return Messages.errorMetricNotFound({METRIC_NAME: metric.name});
      case MetricErrorCode.MetricNameAlreadyExistsInDestinationProject:
        return destinationType === DestinationItemType.personalSpace ?
          Messages.errorContentNameAlreadyExistsInPersonalSpace({CONTENT_TYPE: L10n.elideIfLong(MetricContentType.name)}) :
          Messages.errorContentNameAlreadyExistsInDestinationProject({CONTENT_TYPE: L10n.elideIfLong(MetricContentType.name)});
      case ContentErrorCode.INVALID_CONTENT_TYPE:
        return Messages.moveContentToPersonalSpaceErrorDetail({CONTENT_TYPE: Messages.metrics()});
      case TagErrorCode.TooManyTags:
        return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
      // Permissions errors
      case MetricErrorCode.MetricMoveInsufficientPermissionsOnMetric:
        return Messages.errorMetricMoveInsufficientPermissions();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorMetricInsufficientPermissions();

      default:
        return Messages.errorUnknown();
    }
  }
}
